import { inject, InjectionToken } from '@angular/core';

export const ENV_PROD_BUILD = new InjectionToken<boolean>('Environment Production Build', {
  factory: () => false,
});

export const injectProduction = () => inject(ENV_PROD_BUILD, { optional: true }) ?? false;
